<template>
  <section class="popup-banner-editor">
    <div class="image-uploader">
      <img :src="thumbnailUrl" class="image img-fluid mb-4" />
      <sc-button class="w-100" @click="handleClickChooseImageButton"
        >อัพโหลดรูปภาพ</sc-button
      >
    </div>
    <div class="detail">
      <div class="mb-4">
        <div class="label">ชื่อ</div>
        <el-input v-model="title"></el-input>
      </div>
      <div class="mb-4">
        <div class="label">ช่วงเวลาแสดงผล</div>
        <date-picker
          v-model="publishDate"
          type="daterange"
          range-separator="ถึง"
        ></date-picker>
      </div>
      <div class="mb-4">
        <div class="label">Web URL</div>
        <el-input v-model="webUrl"></el-input>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </section>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import DatePicker from "@/lib/components/DatePicker";
import ImagePickerModal from "@/lib/components/ImagePickerModal";

function bindField(name) {
  return {
    get() {
      return this.value[name];
    },
    set(val) {
      this.$emit("input", { ...this.value, [name]: val });
    }
  };
}

const PLACEHOLDER_THUMBNAIL_URL = "https://placehold.co/700x1000";
const IMAGE_PICKER_CONFIG = {
  title: "เลือกรูป",
  width: 350,
  height: 500,
  recommendWidth: 700,
  recommendHeight: 1000
};

export default {
  components: {
    ScButton,
    "el-input": Input,
    DatePicker,
    ImagePickerModal
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShowModal: false,
      fileThumbnailUrl: null
    };
  },
  computed: {
    chooseImageDialog() {
      return {
        ...IMAGE_PICKER_CONFIG,
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.thumbnailUrl
      };
    },
    thumbnailUrl() {
      return (
        this.fileThumbnailUrl ||
        this.imageUrl ||
        PLACEHOLDER_THUMBNAIL_URL
      );
    },
    title: bindField("title"),
    webUrl: bindField("webUrl"),
    publishDate: bindField("publishDate")
  },
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        if (val?.imageFile === oldVal?.imageFile) {
          return;
        }

        if (this.fileThumbnailUrl) {
          URL.revokeObjectURL(this.fileThumbnailUrl);
          this.fileThumbnailUrl = null;
        }

        if (val?.imageFile) {
          this.fileThumbnailUrl = URL.createObjectURL(val.imageFile);
        }
      }
    }
  },
  beforeDestroy() {
    if (this.fileThumbnailUrl) {
      URL.revokeObjectURL(this.fileThumbnailUrl);
    }
  },
  methods: {
    handleCancelChooseImageDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file });
      this.isShowModal = false;
    },
    handleClickChooseImageButton() {
      this.isShowModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.popup-banner-editor {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 350px 1fr;

  .image {
    border: $border;
  }
}
</style>
